/*
  carrinho.js — adicionar ao carrinho via AJAX + carrinho lateral (drawer)
  ============================================================
  - Intercepta o envio de qualquer formulário de add-to-cart, chama
    /cart/add.js e, se o drawer existir (snippet carrinho, Configurações
    › Carrinho lateral), abre o painel com a animação da borboleta.
  - O drawer lê /cart.js e monta os itens; +/- e remover usam
    /cart/change.js e remontam o painel, sem recarregar a página.
  - Mensagem do WhatsApp do drawer: início vem das configurações,
    itens e subtotal entram automaticamente ([unidade] é trocado pela
    janela de unidades, em motion.js).
  - Sem JS, o formulário de produto envia para /cart/add normalmente.
*/
(function () {
  'use strict';
  var root = function () { return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'; };
  var drawer = document.querySelector('[data-cart-drawer]');
  var moeda = drawer ? drawer.getAttribute('data-moeda') || 'R$ 0,00' : 'R$ 0,00';

  // Barra de frete grátis: alvo em centavos vem do data-fg-alvo do drawer.
  function fgUpdate(totalCents) {
    var box = document.querySelector('[data-cd-fg]');
    if (!box) return;
    var alvo = parseInt(box.getAttribute('data-fg-alvo'), 10) || 0;
    if (!alvo) return;
    var falta = alvo - totalCents;
    var txt = box.querySelector('[data-cd-fg-txt]');
    var bar = box.querySelector('[data-cd-fg-bar]');
    if (falta <= 0) {
      box.classList.add('cd__fg--ok');
      if (txt) txt.textContent = box.getAttribute('data-fg-ok') || '';
      if (bar) bar.style.width = '100%';
    } else {
      box.classList.remove('cd__fg--ok');
      if (txt) txt.textContent = (box.getAttribute('data-fg-falta') || '').replace('[valor]', money(falta));
      if (bar) bar.style.width = Math.min(100, Math.round(totalCents / alvo * 100)) + '%';
    }
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return moeda.replace(/0[.,]00|0/, v);
  }
  function updateCartCount(count) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; }); }
  function fetchCart() { return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- ofertas: agrupar linhas por produto e trocar para o kit certo ---------- */
  var KIT = drawer ? (drawer.getAttribute('data-kit-opcao') || 'Oferta') : 'Oferta';
  var TX = { econ: drawer ? drawer.getAttribute('data-economia') || '' : '', un: drawer ? drawer.getAttribute('data-unidade') || 'unidade' : 'unidade', uns: drawer ? drawer.getAttribute('data-unidades') || 'unidades' : 'unidades' };
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) productCache[handle] = fetch(root() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return productCache[handle];
  }
  function unitsOf(v) { var m = String(v).match(/\d+/); return m ? parseInt(m[0], 10) : 1; }
  function analyze(cart) {
    return Promise.all(cart.items.map(function (it) { return getProduct(it.handle); })).then(function (products) {
      var groups = [], map = {};
      cart.items.forEach(function (it, i) {
        var prod = products[i], kitIdx = prod && prod.options ? prod.options.findIndex(function (o) { return o.name === KIT; }) : -1;
        if (kitIdx < 0) { groups.push({ key: 'line' + i, items: [it], units: it.quantity, kits: null, base: null, kitIdx: -1 }); return; }
        var others = it.variant_options.filter(function (_, k) { return k !== kitIdx; });
        var key = it.handle + '|' + others.join('|');
        if (!map[key]) {
          var kits = prod.variants.filter(function (v) { return v.available && v.price > 0 && v.options.filter(function (_, k) { return k !== kitIdx; }).join('|') === others.join('|'); })
            .map(function (v) { return { id: v.id, units: unitsOf(v.options[kitIdx]), price: v.price, compare: v.compare_at_price || 0, title: v.options[kitIdx] }; }).sort(function (a, b) { return b.units - a.units; });
          map[key] = { key: key, items: [], units: 0, kits: kits, base: kits.filter(function (k) { return k.units === 1; })[0] || null, kitIdx: kitIdx, others: others };
          groups.push(map[key]);
        }
        map[key].items.push(it); map[key].units += unitsOf(it.variant_options[kitIdx]) * it.quantity;
      });
      return groups;
    });
  }
  function desired(group, units) {
    var out = {}, rem = units;
    group.kits.forEach(function (k) { if (k.units > 1 && rem >= k.units) { var n = Math.floor(rem / k.units); out[k.id] = n; rem -= n * k.units; } });
    if (rem > 0 && group.base) out[group.base.id] = (out[group.base.id] || 0) + rem;
    return out;
  }
  function applyGroup(group, units) {
    var want = desired(group, units), updates = {};
    group.items.forEach(function (it) { updates[it.variant_id] = 0; });
    Object.keys(want).forEach(function (id) { updates[id] = want[id]; });
    return fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function (r) { return r.json(); });
  }
  function normalize(cart) {
    return analyze(cart).then(function (groups) {
      var updates = {}, changed = false;
      groups.forEach(function (g) {
        if (!g.kits || !g.kits.length) return;
        var want = desired(g, g.units), cur = {};
        g.items.forEach(function (it) { cur[it.variant_id] = (cur[it.variant_id] || 0) + it.quantity; });
        var keys = Object.keys(want).concat(Object.keys(cur));
        keys.forEach(function (id) { if ((want[id] || 0) !== (cur[id] || 0)) { changed = true; updates[id] = want[id] || 0; } });
      });
      if (!changed) return { cart: cart, changed: false };
      return fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function (r) { return r.json(); }).then(function (c) { return { cart: c, changed: true }; });
    });
  }
  window.bellaCartNormalize = function () { return fetchCart().then(normalize); };

  /* ---------- drawer ---------- */
  var lastGroups = [];
  function render(cart) {
    if (!drawer) return Promise.resolve();
    return analyze(cart).then(function (groups) {
      lastGroups = groups;
      var totalUnits = groups.reduce(function (a, g) { return a + g.units; }, 0);
      updateCartCount(totalUnits);
      var items = drawer.querySelector('[data-cd-items]'), empty = drawer.querySelector('[data-cd-empty]'), foot = drawer.querySelector('[data-cd-foot]'), count = drawer.querySelector('[data-cd-count]');
      count.textContent = totalUnits ? totalUnits + ' ' + (totalUnits === 1 ? (drawer.getAttribute('data-item') || 'item') : (drawer.getAttribute('data-itens') || 'itens')) : '';
      if (!cart.item_count) { items.innerHTML = ''; empty.hidden = false; foot.hidden = true; drawer.querySelectorAll('[data-rel-handle]').forEach(function (el) { el.hidden = false; }); return; }
      empty.hidden = true; foot.hidden = false;
      var rm = drawer.getAttribute('data-remover') || 'Remover';
      items.innerHTML = groups.map(function (g, i) {
        var it = g.items[0], img = it.featured_image && it.featured_image.url ? it.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : '';
        var nome = it.product_title;
        var sub = g.kits ? g.others.join(' · ') : (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '');
        var total = g.items.reduce(function (a, x) { return a + x.final_line_price; }, 0);
        var kitsUsed = g.kits ? g.items.filter(function (x) { return unitsOf(x.variant_options[g.kitIdx]) > 1; }).map(function (x) { return x.variant_options[g.kitIdx]; }) : [];
        var cheio = g.base ? g.base.price * g.units : 0;
        /* oferta: soma dos preços "de" (Preço comparativo) das linhas, quando for maior */
        if (g.kits) {
          var cmpTotal = g.items.reduce(function (a, x) { var k = g.kits.filter(function (kk) { return kk.id === x.variant_id; })[0]; return a + Math.max(k ? k.compare : 0, x.price) * x.quantity; }, 0);
          if (cmpTotal > cheio) cheio = cmpTotal;
        }
        var save = cheio ? cheio - total : 0;
        var saveHtml = save > 0 && TX.econ ? '<span class="cd__save">' + esc(TX.econ.replace('[valor]', money(save)).replace('[oferta]', kitsUsed.filter(function (v, k, a) { return a.indexOf(v) === k; }).join(' + '))) + '</span>' : '';
        var priceHtml = (save > 0 ? '<s>' + money(cheio) + '</s>' : '') + '<strong>' + money(total) + '</strong>' + saveHtml;
        var qtyLabel = g.kits ? g.units : it.quantity;
        return '<div class="cd__item" style="animation-delay:' + (i * 50) + 'ms" data-group="' + i + '">' +
          '<a class="cd__tile" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><h3 class="cd__name"><a href="' + esc(it.url) + '">' + esc(nome) + '</a></h3>' + (sub ? '<p class="cd__var">' + esc(sub) + '</p>' : '') +
          '<div class="cd__ctrl"><span class="cd__qty"><button type="button" data-cd-minus aria-label="-">&minus;</button><span>' + qtyLabel + '</span><button type="button" data-cd-plus aria-label="+">&plus;</button></span>' +
          '<button type="button" class="cd__rm" data-cd-rm>' + esc(rm) + '</button></div></div>' +
          '<div class="cd__line">' + priceHtml + '</div></div>';
      }).join('');
      drawer.querySelector('[data-cd-subtotal]').textContent = money(cart.total_price);
      fgUpdate(cart.total_price);
      var tpl = drawer.getAttribute('data-wa-tpl') || '';
      var msg = tpl + cart.items.map(function (it) {
        var nome = it.product_title;
        var v = it.variant_title && it.variant_title !== 'Default Title' ? ' (' + it.variant_title + ')' : '';
        return '\n• ' + it.quantity + 'x ' + nome + v + ' — ' + money(it.final_line_price);
      }).join('') + '\nSubtotal: ' + money(cart.total_price);
      var wa = drawer.querySelector('[data-cd-wa]'); if (wa) wa.setAttribute('data-wa-message', msg);
      var no = {}; cart.items.forEach(function (it) { no[it.handle] = true; });
      drawer.querySelectorAll('[data-rel-handle]').forEach(function (el) { el.hidden = !!no[el.getAttribute('data-rel-handle')]; });
    });
  }
  function setUnits(gi, units) {
    var g = lastGroups[gi]; if (!g) return;
    drawer.classList.add('is-busy');
    var p = g.kits && g.kits.length ? applyGroup(g, Math.max(0, units)) : fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: g.items[0].key, quantity: Math.max(0, units) }) }).then(function (r) { return r.json(); });
    p.then(render).catch(function () {}).finally(function () { drawer.classList.remove('is-busy'); });
  }
  function openDrawer(fromEl, added) {
    if (!drawer) return;
    var addedEl = drawer.querySelector('[data-cd-added]'); if (addedEl) addedEl.hidden = !added;
    var fly = added && fromEl && drawer.getAttribute('data-borboleta') === 'true' && !document.documentElement.classList.contains('motion-reduce');
    if (fly) {
      var r = fromEl.getBoundingClientRect(), bx = r.left + r.width / 2, by = r.top + r.height / 2;
      var tx = Math.min(window.innerWidth - 16, window.innerWidth - Math.min(440, window.innerWidth) + 24) - bx, ty = 70 - by;
      var b = drawer.querySelector('[data-cd-bfly]');
      b.style.setProperty('--bx', bx + 'px'); b.style.setProperty('--by', by + 'px'); b.style.setProperty('--tx', tx + 'px'); b.style.setProperty('--ty', ty + 'px');
      drawer.classList.remove('is-flying'); void b.offsetWidth; drawer.classList.add('is-flying');
      setTimeout(function () { drawer.classList.remove('is-flying'); }, 1000);
    }
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('cd-open');
    var close = drawer.querySelector('.cd__close'); if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 500);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open', 'is-flying'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('cd-open');
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var item = e.target.closest('.cd__item'); if (!item) return;
      var gi = parseInt(item.getAttribute('data-group'), 10), q = parseInt(item.querySelector('.cd__qty span').textContent, 10);
      if (e.target.closest('[data-cd-plus]')) setUnits(gi, q + 1);
      else if (e.target.closest('[data-cd-minus]')) setUnits(gi, q - 1);
      else if (e.target.closest('[data-cd-rm]')) setUnits(gi, 0);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
    /* ícone do carrinho no cabeçalho abre o drawer (fora da página do carrinho) */
    /* Checkout de terceiros (Yampi): o snippet dela expõe window.yampiClick(), que lê o carrinho,
       cria o pedido na Yampi e redireciona. Sem a Yampi, o link segue para o checkout nativo. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-cd-checkout]');
      if (!a || typeof window.yampiClick !== 'function') return;
      e.preventDefault();
      a.setAttribute('aria-busy', 'true');
      try { window.yampiClick(); } catch (err) { window.location.href = a.href; }
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a.header__cart, [data-cart-open]');
      if (!a || document.body.classList.contains('template-cart')) return;
      e.preventDefault(); fetchCart().then(normalize).then(function (r) { render(r.cart).then(function () { openDrawer(null, false); }); });
    });
    /* fechar o drawer ao clicar em um botão do WhatsApp dentro dele (a janela de unidades abre por cima) */
  }

  /* ---------- add to cart ---------- */
  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"], [name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (item) { try { document.dispatchEvent(new CustomEvent('bella:add', { detail: item })); } catch (e) {} return fetchCart(); })
      .then(function (cart) { return normalize(cart).then(function (r) { return r.cart; }); })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        if (drawer) { render(cart).then(function () { openDrawer(button, true); }); }
        else {
          updateCartCount(cart.item_count);
          if (typeof window.mostrarAlerta === 'function') window.mostrarAlerta((window.themeStrings && window.themeStrings.addedToCart) || 'Adicionado ao carrinho', 'positivo');
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  }
  document.addEventListener('submit', handleSubmit);
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(normalize).then(function (r) {
      if (document.body.classList.contains('template-cart') && r.changed) { window.location.reload(); return; }
      if (drawer) render(r.cart); else updateCartCount(r.cart.item_count);
    }).catch(function () {});
  });
})();
